(() => {
  const mediaQuery = window.matchMedia('(min-width: 880px)');
  const showMedia = (gallery, id) => {
    if (!gallery || !id) return;
    const panels = Array.from(gallery.querySelectorAll('[data-media]'));
    if (!panels.some(panel => panel.dataset.media === String(id))) return;
    panels.forEach(panel => {
      const active = panel.dataset.media === String(id);
      panel.hidden = !active;
      if (!active) panel.querySelectorAll('video').forEach(video => video.pause());
    });
    gallery.querySelectorAll('[data-gallery-trigger]').forEach(link => {
      link.setAttribute('aria-current', link.dataset.galleryTrigger === String(id) ? 'true' : 'false');
    });
  };
  const showSunPanel = (tabs, id) => {
    tabs.querySelectorAll('[data-sun-tab]').forEach(tab => {
      const selected = tab.getAttribute('aria-controls') === id;
      tab.setAttribute('aria-selected', String(selected));
      tab.tabIndex = selected ? 0 : -1;
    });
    tabs.querySelectorAll('[data-sun-panel]').forEach(panel => { panel.hidden = panel.id !== id; });
  };
  const initSunTabs = tabs => {
    const nav = tabs.querySelector('.sun-product__tablist');
    const links = Array.from(nav.querySelectorAll('[data-sun-tab]'));
    nav.setAttribute('role', 'tablist');
    links.forEach(link => {
      const panel = document.getElementById(link.hash.slice(1));
      link.id = panel.id + '-tab';
      link.setAttribute('role', 'tab');
      link.setAttribute('aria-controls', panel.id);
      panel.setAttribute('role', 'tabpanel');
      panel.setAttribute('aria-labelledby', link.id);
      panel.tabIndex = 0;
    });
    const selected = links.find(link => link.hash === window.location.hash) || links[0];
    showSunPanel(tabs, selected.getAttribute('aria-controls'));
  };
  const updateNavigation = () => {
    document.querySelectorAll('[data-header]').forEach(header => {
      const toggle = header.querySelector('[data-menu-toggle]');
      const nav = header.querySelector('.site-nav');
      if (!toggle || !nav) return;
      toggle.hidden = mediaQuery.matches;
      nav.hidden = !mediaQuery.matches;
      toggle.setAttribute('aria-expanded', String(mediaQuery.matches));
    });
  };
  const enhance = root => {
    root.querySelectorAll('[data-quantity-step]').forEach(button => { button.hidden = false; });
    root.querySelectorAll('[data-gallery]').forEach(gallery => {
      const first = gallery.querySelector('[data-media]');
      showMedia(gallery, gallery.dataset.initialMedia || (first && first.dataset.media));
    });
    root.querySelectorAll('[data-sun-tabs]').forEach(initSunTabs);
    root.querySelectorAll('[data-sun-styles]').forEach(styles => {
      const field = styles.closest('form').querySelector('.variant-field');
      if (!field || !styles.querySelector('[data-sun-variant]')) return;
      styles.hidden = false;
      field.hidden = true;
    });
    updateNavigation();
  };
  document.documentElement.classList.add('js');
  enhance(document);
  mediaQuery.addEventListener('change', updateNavigation);
  document.addEventListener('shopify:section:load', event => enhance(event.target));
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (nav) {
        nav.hidden = !nav.hidden;
        toggle.setAttribute('aria-expanded', String(!nav.hidden));
      }
    }
    const galleryLink = event.target.closest('[data-gallery-trigger]');
    if (galleryLink) {
      event.preventDefault();
      showMedia(galleryLink.closest('[data-gallery]'), galleryLink.dataset.galleryTrigger);
    }
    const choice = event.target.closest('[data-sun-variant]');
    if (choice) {
      const select = choice.closest('[data-product-section]').querySelector('[data-variant-select]');
      select.value = choice.dataset.sunVariant;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const tabLink = event.target.closest('[data-sun-tab], [data-sun-panel-link]');
    if (tabLink) {
      const panel = document.getElementById(tabLink.hash.slice(1));
      const tabs = panel && panel.closest('[data-sun-tabs]');
      if (tabs) {
        showSunPanel(tabs, panel.id);
        if (tabLink.hasAttribute('data-sun-tab')) event.preventDefault();
      }
    }
    const stepper = event.target.closest('[data-quantity-step]');
    if (stepper) {
      const field = stepper.closest('.quantity-control').querySelector('input');
      const increment = Number(field.step) || 1;
      const minimum = Number(field.min) || 1;
      const maximum = field.max === '' ? Infinity : Number(field.max);
      const next = Number(field.value) + Number(stepper.dataset.quantityStep) * increment;
      field.value = String(Math.min(maximum, Math.max(minimum, next)));
      field.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
  document.addEventListener('change', event => {
    if (!event.target.matches('[data-variant-select]')) return;
    const select = event.target;
    const option = select.selectedOptions[0];
    const section = select.closest('[data-product-section]');
    if (!option || !section) return;
    const price = section.querySelector('[data-product-price]');
    const compare = section.querySelector('[data-compare-price]');
    const button = section.querySelector('[data-add-button]');
    const label = section.querySelector('[data-add-label]');
    const quantity = section.querySelector('[name="quantity"]');
    if (price) price.textContent = option.dataset.price;
    if (compare) {
      compare.textContent = option.dataset.compare;
      compare.hidden = option.dataset.sale !== 'true';
    }
    if (button) button.disabled = option.dataset.available !== 'true';
    if (label) label.textContent = option.dataset.available === 'true' ? label.dataset.availableLabel : label.dataset.soldLabel;
    if (quantity) {
      quantity.min = option.dataset.min || '1';
      quantity.step = option.dataset.step || '1';
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      const minimum = Number(quantity.min);
      const step = Number(quantity.step);
      const adjusted = minimum + Math.ceil(Math.max(0, Number(quantity.value) - minimum) / step) * step;
      quantity.value = String(quantity.max ? Math.min(Number(quantity.max), adjusted) : adjusted);
    }
    const sunStyle = section.querySelector('[data-sun-style-name]');
    if (sunStyle) {
      sunStyle.textContent = option.dataset.style;
      section.querySelectorAll('[data-sun-variant]').forEach(choice => {
        choice.setAttribute('aria-pressed', String(choice.dataset.sunVariant === select.value));
      });
    }
    showMedia(section.querySelector('[data-gallery]'), option.dataset.media);
    const url = new URL(window.location.href);
    url.searchParams.set('variant', select.value);
    window.history.replaceState(null, '', url);
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-sun-tab]');
    if (tab && event.key === ' ') {
      event.preventDefault();
      tab.click();
      return;
    }
    if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
      const links = Array.from(tab.parentElement.querySelectorAll('[data-sun-tab]'));
      const index = links.indexOf(tab);
      const next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1
        : (index + (event.key === 'ArrowRight' ? 1 : -1) + links.length) % links.length;
      event.preventDefault();
      links[next].focus();
      showSunPanel(tab.closest('[data-sun-tabs]'), links[next].getAttribute('aria-controls'));
      return;
    }
    if (event.key !== 'Escape' || mediaQuery.matches) return;
    document.querySelectorAll('[data-header]').forEach(header => {
      const toggle = header.querySelector('[data-menu-toggle]');
      const nav = header.querySelector('.site-nav');
      if (toggle && nav && !nav.hidden) {
        nav.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      }
    });
  });
})();

